import React from 'react'
import NewPackingList from '../../components/packing_list/NewPackingList';

const NewPackingListPage = () => {
    return (
        <div 
            className="d-flex flex-column h-100 overflow-hidden py-2 py-md-3"
            style={{ boxSizing: 'border-box' }}
        >
            {/* Centred, width-constrained container — matches reference image side margins */}
            <div
                className="d-flex flex-column flex-grow-1 overflow-hidden mx-auto w-100 px-3 px-md-5"
                style={{ maxWidth: '980px' }}
            >
                <NewPackingList />
            </div>
        </div>
    )
}

export default NewPackingListPage